import { render, staticRenderFns } from "./IconSlack.vue?vue&type=template&id=d5c9a406"
import script from "./IconSlack.vue?vue&type=script&lang=js"
export * from "./IconSlack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports